import groq from "groq"

export const getEmployeesByNumber = async (employeeNumber, sanityClient) => {
  const draftsFilter = `&& !(_id in path("drafts.**"))`

  const employees = await sanityClient.fetch(
    groq`*[_type=="employee" && key==$employeeNumber ${draftsFilter}][0] {
          "name": name,
          "number": key,
        }`,
    { employeeNumber },
  )

  return { ...employees }
}
